'use strict'

var htmlElement = document.documentElement;

function setMarginTop(){
  htmlElement.setAttribute('data-reset-scroll', window.pageYOffset)
  htmlElement.style.top = -(window.pageYOffset)+'px';
}

function resetMarginTop() {
  htmlElement.style.top = '';
  window.scrollTo(0, htmlElement.dataset.resetScroll);
  htmlElement.removeAttribute('data-reset-scroll')
}

module.exports = {
  setMarginTop: setMarginTop,
  resetMarginTop : resetMarginTop
};